document.addEventListener('click', function(e) {
    if (e.target && e.target.matches('.js-card-icon-favorite')) {
        e.stopPropagation();
        e.preventDefault();
        var event = new CustomEvent('favoriteIconClicked', {
            detail: { id: e.target.closest('.js-card').dataset.id }
        });
        document.dispatchEvent(event);
    }
});

document.addEventListener('favoriteIconClicked', function(e) {
    // console.log('Favorite icon clicked, id:', e.detail.id);
    // You can now use the id as needed
});






